// Copyright (c) 2022 by Move Closer

import { IconsRegistry } from '@/shared/core/src/front/shared/icons/icons.contracts'

/**
 * Main registry of icons.
 *
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const iconsRegistry: IconsRegistry = {
  Close: {
    label: 'Close',
    component: () => import(/* webpackChunkName: "icons-base" */ './CloseIcon.vue')
  },
  Heart: {
    label: 'Heart',
    component: () => import(/* webpackChunkName: "icons-base" */ './HeartIcon.vue')
  },
  User: {
    label: 'User',
    component: () => import(/* webpackChunkName: "icons-base" */ './UserIcon.vue')
  },
  SimpleStoreLogo: {
    label: 'SimpleStoreLogo',
    component: () => import(/* webpackChunkName: "icons-base" */ './SimpleStoreLogoIcon.vue')
  },
  SearchWithLines: {
    label: 'SearchWithLines',
    component: () => import(/* webpackChunkName: "icons-base" */ './SearchWithLinesIcon.vue')
  },
  StoreLogo: {
    label: 'StoreLogo',
    component: () => import(/* webpackChunkName: "icons-base" */ './StoreLogoIcon.vue')
  },
  ArrowDown: {
    label: 'ArrowDown',
    component: () => import(/* webpackChunkName: "icons-base" */ './ArrowDownIcon.vue')
  },
  ArrowUp: {
    label: 'ArrowUp',
    component: () => import(/* webpackChunkName: "icons-base" */ './ArrowUpIcon.vue')
  },
  ArrowRight: {
    label: 'ArrowRight',
    component: () => import(/* webpackChunkName: "icons-base" */ './ArrowRightIcon.vue')
  },
  Bag: {
    label: 'Bag',
    component: () => import(/* webpackChunkName: "icons-base" */ './BagIcon.vue')
  },
  CalendarCheck: {
    label: 'CalendarCheck',
    component: () => import(/* webpackChunkName: "icons-base" */ './CalendarCheckIcon.vue')
  },
  CaretDown: {
    label: 'CaretDown',
    component: () => import(/* webpackChunkName: "icons-base" */ './CaretDownIcon.vue')
  },
  CaretLeft: {
    label: 'CaretLeft',
    component: () => import(/* webpackChunkName: "icons-base" */ './CaretLeftIcon.vue')
  },
  CaretRight: {
    label: 'CaretRight',
    component: () => import(/* webpackChunkName: "icons-base" */ './CaretRightIcon.vue')
  },
  CaretUp: {
    label: 'CaretUp',
    component: () => import(/* webpackChunkName: "icons-base" */ './CaretUpIcon.vue')
  },
  ChatCircleText: {
    label: 'ChatCircleText',
    component: () => import(/* webpackChunkName: "icons/ChatCircleText" */ './ChatCircleTextIcon.vue')
  },
  CosmeticSamplesAsGift: {
    label: 'CosmeticSamplesAsGift',
    component: () => import(/* webpackChunkName: "icons/CosmeticSamplesAsGift" */ './CosmeticSamplesAsGiftIcon.vue')
  },
  CreditCard: {
    label: 'CreditCard',
    component: () => import(/* webpackChunkName: "icons/CreditCard" */ './CreditCardIcon.vue')
  },
  DeferredPayments: {
    label: 'DeferredPayments',
    component: () => import(/* webpackChunkName: "icons/DeferredPayments" */ './DeferredPaymentsIcon.vue')
  },
  DeliveryByTomorrow: {
    label: 'DeliveryByTomorrow',
    component: () => import(/* webpackChunkName: "icons/DeliveryByTomorrow" */ './DeliveryByTomorrowIcon.vue')
  },
  Discount: {
    label: 'Discount',
    component: () => import(/* webpackChunkName: "icons/Discount" */ './DiscountIcon.vue')
  },
  DHL: {
    label: 'DHL',
    component: () => import(/* webpackChunkName: "icons-checkout" */ './DHLIcon.vue')
  },
  DPD: {
    label: 'DPD',
    component: () => import(/* webpackChunkName: "icons-checkout" */ './DPDIcon.vue')
  },
  EcoFriendlyPackaging: {
    label: 'EcoFriendlyPackaging',
    component: () => import(/* webpackChunkName: "icons/EcoFriendlyPackaging" */ './EcoFriendlyPackagingIcon.vue')
  },
  Envelope: {
    label: 'Envelope',
    component: () => import(/* webpackChunkName: "icons-base" */ './EnvelopeIcon.vue')
  },
  Facebook: {
    label: 'Facebook',
    component: () => import(/* webpackChunkName: "icons-base" */ './FacebookIcon.vue')
  },
  FacebookSimple: {
    label: 'FacebookSimple',
    component: () => import(/* webpackChunkName: "icons-base" */ './FacebookSimpleIcon.vue')
  },
  FacebookSignIn: {
    label: 'FacebookSignIn',
    component: () => import(/* webpackChunkName: "icons-base" */ './FacebookSignIn.vue')
  },
  Filters: {
    label: 'Filters',
    component: () => import(/* webpackChunkName: "icons-base" */ './FiltersIcon.vue')
  },
  FiltersLineThrough: {
    label: 'FiltersLineThrough',
    component: () => import(/* webpackChunkName: "icons-base" */ './FiltersLineThroughIcon.vue')
  },
  FiltersTrigger: {
    label: 'FiltersTrigger',
    component: () => import(/* webpackChunkName: "icons-base" */ './FiltersTriggerIcon.vue')
  },
  FlagWithHeart: {
    label: 'FlagWithHeart',
    component: () => import(/* webpackChunkName: "icons-base" */ './FlagWithHeartIcon.vue')
  },
  FullStar: {
    label: 'FullStar',
    component: () => import(/* webpackChunkName: "icons-base" */ './FullStarIcon.vue')
  },
  FreeDelivery: {
    label: 'FreeDelivery',
    component: () => import(/* webpackChunkName: "icons-base" */ './FreeDeliveryIcon.vue')
  },
  GoogleSignIn: {
    label: 'GoogleSignIn',
    component: () => import(/* webpackChunkName: "icons-base" */ './GoogleSignIn.vue')
  },
  HalfStar: {
    label: 'HalfStar',
    component: () => import(/* webpackChunkName: "icons-base" */ './HalfStarIcon.vue')
  },
  Hamburger: {
    label: 'Hamburger',
    component: () => import(/* webpackChunkName: "icons-base" */ './HamburgerIcon.vue')
  },
  HeartWithGrayCircle: {
    label: 'HeartWithGrayCircle',
    component: () => import(/* webpackChunkName: "icons-base" */ './HeartWithGrayCircleIcon.vue')
  },
  HeartWithRedCircle: {
    label: 'HeartWithRedCircle',
    component: () => import(/* webpackChunkName: "icons-base" */ './HeartWithRedCircleIcon.vue')
  },
  Info: {
    label: 'Info',
    component: () => import(/* webpackChunkName: "icons-base" */ './InfoIcon.vue')
  },
  Inpost: {
    label: 'Inpost',
    component: () => import(/* webpackChunkName: "icons-checkout" */ './InpostIcon.vue')
  },
  Instagram: {
    label: 'Instagram',
    component: () => import(/* webpackChunkName: "icons-base" */ './InstagramIcon.vue')
  },
  Kameleon: {
    label: 'Kameleon',
    component: () => import(/* webpackChunkName: "icons-base" */ './KameleonIcon.vue')
  },
  Leaf: {
    label: 'Leaf',
    component: () => import(/* webpackChunkName: "icons-base" */ './LeafIcon.vue')
  },
  LoadingIcon: {
    label: 'Loading',
    component: () => import(/* webpackChunkName: "icons-base" */ './LoadingIcon.vue')
  },
  Minus: {
    label: 'Minus',
    component: () => import(/* webpackChunkName: "icons-base" */ './MinusIcon.vue')
  },
  NotFound: {
    label: 'NotFound',
    component: () => import(/* webpackChunkName: "icons/NotFound" */ './NotFoundIcon.vue')
  },
  Phone: {
    label: 'Phone',
    component: () => import(/* webpackChunkName: "icons-base" */ './PhoneIcon.vue')
  },
  Plus: {
    label: 'Plus',
    component: () => import(/* webpackChunkName: "icons-base" */ './PlusIcon.vue')
  },
  PlayIcon: {
    label: 'Play',
    component: () => import(/* webpackChunkName: "icons-base" */ './PlayIcon.vue')
  },
  Tote: {
    label: 'Tote',
    component: () => import(/* webpackChunkName: "icons-base" */ './ToteIcon.vue')
  },
  Trash: {
    label: 'Trash',
    component: () => import(/* webpackChunkName: "icons-base" */ './TrashIcon.vue')
  },
  Truck: {
    label: 'Truck',
    component: () => import(/* webpackChunkName: "icons-base" */ './TruckIcon.vue')
  },
  Youtube: {
    label: 'Youtube',
    component: () => import(/* webpackChunkName: "icons-base" */ './YoutubeIcon.vue')
  },
  Set: {
    label: 'Set',
    component: () => import(/* webpackChunkName: "icons-base" */ './SetIcon.vue')
  },
  ShoppingCartFull: {
    label: 'ShoppingCartFull',
    component: () => import(/* webpackChunkName: "icons-base" */ './ShoppingCartFullIcon.vue')
  },
  SimpleArrowLeft: {
    label: 'SimpleArrowLeft',
    component: () => import(/* webpackChunkName: "icons-base" */ './SimpleArrowLeftIcon.vue')
  },
  SimpleArrowRight: {
    label: 'SimpleArrowRight',
    component: () => import(/* webpackChunkName: "icons-base" */ './SimpleArrowRightIcon.vue')
  },
  Squares: {
    label: 'SquaresIcon',
    component: () => import(/* webpackChunkName: "icons/Squares" */ './SquaresIcon.vue')
  },

  // Payment & Delivery
  ApplePay: {
    label: 'ApplePay',
    component: () => import(/* webpackChunkName: "icons-checkout" */ './ApplePayIcon.vue')
  },
  Blik: {
    label: 'Blik',
    component: () => import(/* webpackChunkName: "icons-checkout" */ './BlikIcon.vue')
  },
  GooglePay: {
    label: 'GooglePay',
    component: () => import(/* webpackChunkName: "icons-checkout" */ './GooglePayIcon.vue')
  },
  MasterCard: {
    label: 'MasterCard',
    component: () => import(/* webpackChunkName: "icons-checkout" */ './MasterCardIcon.vue')
  },
  Pay24Now: {
    label: 'Pay24Now',
    component: () => import(/* webpackChunkName: "icons-checkout" */ './Pay24NowIcon.vue')
  },
  PayPo: {
    label: 'PayPo',
    component: () => import(/* webpackChunkName: "icons-checkout" */ './PayPoIcon.vue')
  },
  Przelewy24: {
    label: 'Przelewy24',
    component: () => import(/* webpackChunkName: "icons-checkout" */ './Przelewy24Icon.vue')
  },
  Visa: {
    label: 'Visa',
    component: () => import(/* webpackChunkName: "icons-checkout" */ './VisaIcon.vue')
  }
}
